import { PAStepModule } from "@/store/modules/paStep.module";
import { toaster } from "@/utilities/toaster";
import { Guid } from "guid-typescript";
import { assign, Machine } from "xstate";
const stepMachine = Machine({
    id: "stepMachine",
    context: {
        stepId: Guid.createEmpty(),
        mode: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: { target: "modalDormant" },
        },
        modalDormant: {
            on: {
                SHOW_STEP: { target: "checkingStepMode", actions: ["assignmode", "assignStep"] },
            },
        },
        checkingStepMode: {
            always: [
                {
                    target: "internalStakeHolder",
                    cond: (cxt, evt) => cxt.mode === "Add",
                },
                {
                    target: "gettingStepDetails",
                    cond: (cxt, evt) => cxt.mode === "Edit",
                },
            ],
        },
        gettingStepDetails: {
            invoke: {
                id: "gettingStepDetails",
                src: (cxt, evt) => {
                    return PAStepModule.GetStepDetailById(cxt.stepId);
                },
                onDone: { target: "loadedStep" },
                onError: { target: "loadedStep" },
            },
        },
        loadedStep: {
            on: {
                CANCEL_STEP: { target: "modalDormant" },
                SAVE_STEP: { target: "savingStep" },
                EDIT_STEP: { target: "updatingStep" },
                INTERNAL_STAKE_HOLDER: { target: "internalStakeHolder" },
                EXTERNAL_STAKE_HOLDER: { target: "externalStakeHolder" },
            },
        },
        internalStakeHolder: {
            initial: "byRole",
            states: {
                byRole: {
                    on: {
                        BY_REPORTING_TO: { target: "byReportingTo" },
                        EXTERNAL_STAKE_HOLDER: { target: "#stepMachine.externalStakeHolder" },
                        CANCEL_STEP: { target: "#stepMachine.modalDormant" },
                        BY_USER: { target: "byUser" },
                        SAVE_STEP: { target: "#stepMachine.savingStep" },
                    },
                },
                byUser: {
                    on: {
                        BY_ROLE: { target: "byRole" },
                        BY_REPORTING_TO: { target: "byReportingTo" },
                        EXTERNAL_STAKE_HOLDER: { target: "#stepMachine.externalStakeHolder" },
                        CANCEL_STEP: { target: "#stepMachine.modalDormant" },
                        SAVE_STEP: { target: "#stepMachine.savingStep" },
                    },
                },
                byReportingTo: {
                    on: {
                        EXTERNAL_STAKE_HOLDER: { target: "#stepMachine.externalStakeHolder" },
                        CANCEL_STEP: { target: "#stepMachine.modalDormant" },
                        BY_USER: { target: "byUser" },
                        BY_ROLE: { target: "byRole" },
                        SAVE_STEP: { target: "#stepMachine.savingStep" },
                    },
                },
            },
        },
        externalStakeHolder: {
            on: {
                INTERNAL_STAKE_HOLDER: { target: "internalStakeHolder" },
                CANCEL_STEP: { target: "modalDormant" },
                SAVE_STEP: { target: "savingStep" },
            },
        },
        savingStep: {
            invoke: {
                id: "savingStep",
                src: (cxt, evt) => {
                    return PAStepModule.AddStep(evt.item);
                },
                onDone: { target: "modalDormant", actions: "showSuccessMessage" },
                onError: { target: "modalDormant" },
            },
        },
        updatingStep: {
            invoke: {
                id: "updatingStep",
                src: (cxt, evt) => {
                    return PAStepModule.EditStep(evt.item);
                },
                onDone: { target: "modalDormant", actions: "showSuccessMessage" },
                onError: { target: "modalDormant" },
            },
        },
        serviceUnavailable: {},
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
        assignmode: assign({
            mode: (context, event) => event.mode,
        }),
        assignStep: assign({
            stepId: (context, event) => event.stepId,
        }),
    },
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 1000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default stepMachine;
